import { ACCOUNT_INFO_PAYLOAD_DEFINITION } from './commonInbounds/accountInfoInbound';
import { ACTION_ERROR_PAYLOAD_DEFINITION } from './commonInbounds/actionErrorInbound';
import { ACTION_RESULT_PAYLOAD_DEFINITION } from './commonInbounds/actionResultInbound';
import { ADD_FRIEND_TO_ALL_PAYLOAD_DEFINITION } from './commonInbounds/addFriendToAllInbound';
import { ADMIN_NEWEST_PLAYERS_LIST_PAYLOAD_DEFINITION } from './commonInbounds/adminNewestPlayersListInbound';
import { BECOME_OWNER_PAYLOAD_DEFINITION } from './commonInbounds/becomeOwnerInbound';
import { FREE_DAILY_BONUS_SUCCESS_PAYLOAD_DEFINITION } from './commonInbounds/freeDailyBonusSuccessInbound';
import { HIDE_FRIEND_REQUEST_PAYLOAD_DEFINITION } from './commonInbounds/hideFriendRequestInbound';
import { INFINITE_LOOP_PAYLOAD_DEFINITION } from './commonInbounds/infiniteLoopInbound';
import { JOIN_LOBBY_PAYLOAD_DEFINITION } from './commonInbounds/joinLobbyInbound';
import { JOIN_ROOM_PAYLOAD_DEFINITION } from './commonInbounds/joinRoomInbound';
import { KEEP_ALIVE_PAYLOAD_DEFINITION } from './commonInbounds/keepAliveInbound';
import { LEGACY_SHOW_PLAYER_INFO_PAYLOAD_DEFINITION } from './commonInbounds/legacyShowPlayerInfoInbound';
import { MESSAGE_BOX_PAYLOAD_DEFINITION } from './commonInbounds/messageBoxInbound';
import { NEWEST_PLAYERS_LIST_PAYLOAD_DEFINITION } from './commonInbounds/newestPlayersListInbound';
import { PLAYER_CHAT_PAYLOAD_DEFINITION } from './commonInbounds/playerChatInbound';
import { REBUY_SUCCESS_PAYLOAD_DEFINITION } from './commonInbounds/rebuySuccessInbound';
import { RECENT_ADMIN_ACTIONS_PAYLOAD_DEFINITION } from './commonInbounds/recentAdminActionsInbound';
import { RECENT_TOURNEY_WINNERS_PAYLOAD_DEFINITION } from './commonInbounds/recentTourneyWinnersInbound';
import { RELOAD_PAYLOAD_DEFINITION } from './commonInbounds/reloadInbound';
import { REMOVE_FRIEND_FROM_ALL_PAYLOAD_DEFINITION } from './commonInbounds/removeFriendFromAllInbound';
import { RENAME_CURRENT_ROOM_PAYLOAD_DEFINITION } from './commonInbounds/renameCurrentRoomInbound';
import { REQUEST_DEBUG_INFO_PAYLOAD_DEFINITION } from './commonInbounds/requestDebugInfoInbound';
import { SELF_DATA_PAYLOAD_DEFINITION } from './commonInbounds/selfDataInbound';
import { SET_ACTIVE_CONTACTS_PAYLOAD_DEFINITION } from './commonInbounds/setActiveContactsInbound';
import { SET_ALL_FRIENDS_PAYLOAD_DEFINITION } from './commonInbounds/setAllFriendsInbound';
import { SET_BAD_BEAT_JACKPOT_AMOUNT_PAYLOAD_DEFINITION } from './commonInbounds/setBadBeatJackpotAmountInbound';
import { SET_BLOCKED_CHAT_PLAYERS_PAYLOAD_DEFINITION } from './commonInbounds/setBlockedChatPlayersInbound';
import { SET_CONTACT_ACTIVE_PAYLOAD_DEFINITION } from './commonInbounds/setContactActiveInbound';
import { SET_CONTACT_INACTIVE_PAYLOAD_DEFINITION } from './commonInbounds/setContactInactiveInbound';
import { SET_POWER_PLAYER_STATUS_PAYLOAD_DEFINITION } from './commonInbounds/setPowerPlayerStatusInbound';
import { SET_ROOM_PLAYER_BANK_PAYLOAD_DEFINITION } from './commonInbounds/setRoomPlayerBankInbound';
import { SHOW_CONFIRM_WINDOW_PAYLOAD_DEFINITION } from './commonInbounds/showConfirmWindowInbound';
import { SHOW_DROP_DOWN_MENU_PAYLOAD_DEFINITION } from './commonInbounds/showDropDownMenuInbound';
import { SHOW_FRIEND_REQUEST_PAYLOAD_DEFINITION } from './commonInbounds/showFriendRequestInbound';
import { SHOW_GIVE_CHIPS_PAYLOAD_DEFINITION } from './commonInbounds/showGiveChipsInbound';
import { SHOW_INCOME_EVENT_PAYLOAD_DEFINITION } from './commonInbounds/showIncomeEventInbound';
import { SHOW_JACKS_TO_CHIPS_PAYLOAD_DEFINITION } from './commonInbounds/showJacksToChipsWindowInbound';
import { SHOW_JACKS_WINDOW_PAYLOAD_DEFINITION } from './commonInbounds/showJacksWindowInbound';
import { SHOW_NEXT_TOURNEY_WINDOW_PAYLOAD_DEFINITION } from './commonInbounds/showNextTourneyWindowInbound';
import { SHOW_PLAYER_DEBUG_INFO_PAYLOAD_DEFINITION } from './commonInbounds/showPlayerDebugInfoInbound';
import { SHOW_PLAYER_INFO_PAYLOAD_DEFINITION } from './commonInbounds/showPlayerInfoInbound';
import { SHOW_POWER_PLAYER_UPGRADE_WINDOW_PAYLOAD_DEFINITION } from './commonInbounds/showPowerPlayerUpgradeWindowInbound';
import { SHOW_PRIZE_WIN_PAYLOAD_DEFINITION } from './commonInbounds/showPrizeWinInbound';
import { SHOW_RANKING_LIST_PAYLOAD_DEFINITION } from './commonInbounds/showRankingListInbound';
import { SHOW_REBUY_WINDOW_PAYLOAD_DEFINITION } from './commonInbounds/showRebuyWindowInbound';
import { SHOW_SELF_INFO_PAYLOAD_DEFINITION } from './commonInbounds/showSelfInfoInbound';
import { SHOW_TEST_EMAIL_LOG_PAYLOAD_DEFINITION } from './commonInbounds/showTestEmailLogInbound';
import { SHOW_TOURNEY_DETAILS_PAYLOAD_DEFINITION } from './commonInbounds/showTourneyDetailsInbound';
import { SHOW_UPCOMING_TOURNEYS_PAYLOAD_DEFINITION } from './commonInbounds/showUpcomingTourneysInbound';
import { TOURNEY_SUMMARY_PAYLOAD_DEFINITION } from './commonInbounds/tourneySummaryInbound';
import { UPDATE_JACKS_AND_AMMO_PAYLOAD_DEFINITION } from './commonInbounds/updateJacksAndAmmoInbound';
import { UPDATE_PLAYER_BLOCKING_PAYLOAD_DEFINITION } from './commonInbounds/updatePlayerBlockingInbound';
import { UPDATE_PLAYER_SERVER_SETTING_PAYLOAD_DEFINITION } from './commonInbounds/updatePlayerServerSettingInbound';
import { DIRECT_MESSAGE_BLANK_PAYLOAD_DEFINITION } from './directMessageInbounds/directMessageBlankInbound';
import { DIRECT_MESSAGE_LOG_PAYLOAD_DEFINITION } from './directMessageInbounds/directMessageLogInbound';
import { DIRECT_MESSAGE_RECEIVED_PAYLOAD_DEFINITION } from './directMessageInbounds/directMessageReceivedInbound';
import { DIRECT_MESSAGES_RECENT_PAYLOAD_DEFINITION } from './directMessageInbounds/directMessagesRecentInbound';
import { AUTO_RECONNECT_INVALID_PAYLOAD_DEFINITION } from './gameEntryInbounds/autoReconnectInvalidInbound';
import { LOGIN_ERROR_PAYLOAD_DEFINITION } from './gameEntryInbounds/loginErrorInbound';
import { LOGIN_NOW_PAYLOAD_DEFINITION } from './gameEntryInbounds/loginNowInbound';
import { SESSION_ID_PAYLOAD_DEFINITION } from './gameEntryInbounds/sessionUuidInbound';
import { SET_LOGIN_STRINGS_PAYLOAD_DEFINITION } from './gameEntryInbounds/setLoginStringsInbound';
import { SHOW_LOGIN_WINDOW_PAYLOAD_DEFINITION } from './gameEntryInbounds/showLoginWindowInbound';
import { SIGN_UP_ERROR_PAYLOAD_DEFINITION } from './gameEntryInbounds/signUpErrorInbound';
import { VERSION_CHECK_RESULTS_PAYLOAD_DEFINITION } from './gameEntryInbounds/versionCheckResultsInbound';
import { ADD_LOBBY_ROOMS_PAYLOAD_DEFINITION } from './lobbyInbounds/addLobbyRoomsInbound';
import { ENTER_LOBBY_PLAYER_PAYLOAD_DEFINITION } from './lobbyInbounds/enterLobbyPlayerInbound';
import { INIT_LOBBY_PAYLOAD_DEFINITION } from './lobbyInbounds/initLobbyInbound';
import { LEAVE_LOBBY_PLAYER_PAYLOAD_DEFINITION } from './lobbyInbounds/leaveLobbyPlayerInbound';
import { LOBBY_GENERIC_CHAT_PAYLOAD_DEFINITION } from './lobbyInbounds/lobbyGenericChatInbound';
import { LOBBY_ROOM_CREATED_PAYLOAD_DEFINITION } from './lobbyInbounds/lobbyRoomCreatedInbound';
import { LOBBY_ROOM_REMOVED_PAYLOAD_DEFINITION } from './lobbyInbounds/lobbyRoomRemovedInbound';
import { LOBBY_ROOMS_DONE_PAYLOAD_DEFINITION } from './lobbyInbounds/lobbyRoomsDoneInbound';
import { RENAME_ROOM_PAYLOAD_DEFINITION } from './lobbyInbounds/renameRoomInbound';
import { SET_LOBBY_PLAYER_BANK_PAYLOAD_DEFINITION } from './lobbyInbounds/setLobbyPlayerBankInbound';
import { UPDATE_LOBBY_ROOM_PAYLOAD_DEFINITION } from './lobbyInbounds/updateLobbyRoomInbound';
import { UPDATE_LOBBY_ROOM_VARIABLE_PAYLOAD_DEFINITION } from './lobbyInbounds/updateLobbyRoomVariableInbound';
import { CLOSE_MTT_TABLE_PAYLOAD_DEFINITION } from './mttInbounds/closeMttTableInbound';
import { NUM_MTT_TABLES_PAYLOAD_DEFINITION } from './mttInbounds/numMttTablesInbound';
import { ENTER_MTT_STAGING_PLAYER_PAYLOAD_DEFINITION } from './mttStagingInbounds/enterMttStagingPlayerInbound';
import { EXIT_MTT_STAGING_TO_LOBBY_PAYLOAD_DEFINITION } from './mttStagingInbounds/exitMttStagingToLobbyInbound';
import { MTT_STAGING_INIT_DATA_PAYLOAD_DEFINITION } from './mttStagingInbounds/initMttStagingInbound';
import { LEAVE_MTT_STAGING_PLAYER_PAYLOAD_DEFINITION } from './mttStagingInbounds/leaveMttStagingPlayerInbound';
import { MTT_STAGING_GENERIC_CHAT_PAYLOAD_DEFINITION } from './mttStagingInbounds/mttStagingGenericChatInbound';
import { MTT_STAGING_TABLES_PAYLOAD_DEFINITION } from './mttStagingInbounds/mttStagingTablesInbound';
import { UPDATE_MTT_STAGING_INFO_PAYLOAD_DEFINITION } from './mttStagingInbounds/updateMttStagingInfoInbound';
import { UPDATE_MTT_STAGING_PLAYER_READY_STATE_PAYLOAD_DEFINITION } from './mttStagingInbounds/updateMttStagingPlayerReadyStateInbound';
import { UPDATE_MTT_STAGING_PLAYERS_PAYLOAD_DEFINITION } from './mttStagingInbounds/updateMttStagingPlayersInbound';
import { UPDATE_MTT_STAGING_TABLE_PAYLOAD_DEFINITION } from './mttStagingInbounds/updateMttStagingTableInbound';
import { ADD_BOMB_PAYLOAD_DEFINITION } from './pokerInbounds/addBombInbound';
import { BET_INBOUND_DEFINITION } from './pokerInbounds/betInbound';
import { BOUNCE_SEATED_PLAYER_PAYLOAD_DEFINITION } from './pokerInbounds/bounceSeatedPlayerInbound';
import { CLEAR_TOURNEY_STANDINGS_INBOUND_DEFINITION } from './pokerInbounds/clearTourneyStandingsInbound';
import { DISCARD_PHASE_PAYLOAD_DEFINITION } from './pokerInbounds/discardPhaseInbound';
import { ENTER_POKER_PLAYER_INBOUND_DEFINITION } from './pokerInbounds/enterPokerPlayerInbound';
import { EXIT_POKER_ROOM_TO_LOBBY_PAYLOAD_DEFINITION } from './pokerInbounds/exitPokerRoomToLobbyInbound';
import { HAND_RANK_PAYLOAD_DEFINITION } from './pokerInbounds/handRankInbound';
import { HAND_RECONNECT_PAYLOAD_DEFINITION } from './pokerInbounds/handReconnectInbound';
import { HAND_WIN_INBOUND_DEFINITION } from './pokerInbounds/handWinInbound';
import { INIT_POKER_ROOM_INBOUND_DEFINITION } from './pokerInbounds/initPokerRoomInbound';
import { LAST_CHIP_STACK_INBOUND_DEFINITION } from './pokerInbounds/lastChipStackInbound';
import { leavePokerPlayerPayloadDefinition } from './pokerInbounds/leavePokerPlayerInbound';
import { NEXT_WIN_ANIMATION_PAYLOAD_DEFINITION } from './pokerInbounds/nextWinAnimationInbound';
import { PLAYER_LOST_CONNECTION_PAYLOAD_DEFINITION } from './pokerInbounds/playerLostConnectionInbound';
import { POKER_ROOM_GENERIC_CHAT_PAYLOAD_DEFINITION } from './pokerInbounds/pokerRoomGenericChatInbound';
import { POKER_ROOM_INFO_PAYLOAD_DEFINITION } from './pokerInbounds/pokerRoomInfoInbound';
import { SET_BLIND_TIMER_PAYLOAD_DEFINITION } from './pokerInbounds/setBlindTimerInbound';
import { SET_DISCARD_PHASE_DONE_PAYLOAD_DEFINITION } from './pokerInbounds/setDiscardPhaseDoneInbound';
import { SET_HAND_REVEALING_PAYLOAD_DEFINITION } from './pokerInbounds/setHandRevealingInbound';
import { SET_HOLE_CARDS_AFTER_DISCARD_PAYLOAD_DEFINITION } from './pokerInbounds/setHoleCardsAfterDiscardInbound';
import { SET_PLAYER_HAS_DISCARDED_PAYLOAD_DEFINITION } from './pokerInbounds/setPlayerHasDiscardedInbound';
import { SET_POKER_ROOM_STATUS_PAYLOAD_DEFINITION } from './pokerInbounds/setPokerRoomStatusInbound';
import { SET_SEATED_PLAYER_AVATAR_PAYLOAD_DEFINITION } from './pokerInbounds/setSeatedPlayerAvatarInbound';
import { SHOW_ALL_IN_COMMUNITY_CARDS_PAYLOAD_DEFINITION } from './pokerInbounds/showAllInCommunityCardsInbound';
import { SHOW_ALL_IN_HANDS_PAYLOAD_DEFINITION } from './pokerInbounds/showAllInHandsInbound';
import { SHOW_BLANK_CHAT_BUBBLE_PAYLOAD_DEFINITION } from './pokerInbounds/showBlankChatBubbleInbound';
import { SHOW_PLAYER_BUBBLE_PAYLOAD_DEFINITION } from './pokerInbounds/showPlayerBubbleInbound';
import { SIDE_BET_ADDED_PAYLOAD_DEFINITION } from './pokerInbounds/sideBetAddedInbound';
import { SIDE_BET_DONE_PAYLOAD_DEFINITION } from './pokerInbounds/sideBetDoneInbound';
import { SIDE_BET_HAND_COMPLETE_PAYLOAD_DEFINITION } from './pokerInbounds/sideBetHandCompleteInbound';
import { SIDE_BET_HAND_INCOMPLETE_PAYLOAD_DEFINITION } from './pokerInbounds/sideBetHandIncompleteInbound';
import { SIDE_BET_PHASE_PAYLOAD_DEFINITION } from './pokerInbounds/sideBetPhaseInbound';
import { SIDE_BET_REFUNDED_PAYLOAD_DEFINITION } from './pokerInbounds/sideBetRefundedInbound';
import { SIT_PAYLOAD_DEFINITION } from './pokerInbounds/sitInbound';
import { SIT_OUT_SELF_STATUS_PAYLOAD_DEFINITION } from './pokerInbounds/sitOutSelfStatusInbound';
import { SIT_OUT_STATUS_PAYLOAD_DEFINITION } from './pokerInbounds/sitOutStatusInbound';
import { STAND_UP_DELAYED_INBOUND_DEFINITION } from './pokerInbounds/standUpDelayedInbound';
import { STAND_UP_INBOUND_DEFINITION } from './pokerInbounds/standUpInbound';
import { START_HAND_INBOUND_DEFINITION } from './pokerInbounds/startHandInbound';
import { START_SEAT_TIMERS_PAYLOAD_DEFINITION } from './pokerInbounds/startSeatTimersInbound';
import { UPDATE_CHIP_STACKS_PAYLOAD_DEFINITION } from './pokerInbounds/updateChipStacksInbound';
import { UPDATE_PLAYER_MEDALS_AND_STYLE_PAYLOAD_DEFINITION } from './pokerInbounds/updatePlayerMedalsAndStyleInbound';
import { UPDATE_PLAYERS_PAYLOAD_DEFINITION } from './pokerInbounds/updatePlayersInbound';
import { UPDATE_POT_AMOUNTS_INBOUND_DEFINITION } from './pokerInbounds/updatePotAmountsInbound';
import { UPDATE_TOURNEY_STANDINGS_INBOUND_DEFINITION } from './pokerInbounds/updateTourneyStandingsInbound';
import { WAIT_PHASE_PAYLOAD_DEFINITION } from './pokerInbounds/waitPhaseInbound';
import { WARN_AGGRO_BETTING_PAYLOAD_DEFINITION } from './pokerInbounds/warnAggroBettingInbound';
import { CHECK_RECOVER_LOGIN_PAYLOAD_DEFINITION } from './recoverLoginInbounds/checkRecoverLoginResultInbound';
import { RESET_PASSWORD_DONE_PAYLOAD_DEFINITION } from './recoverLoginInbounds/resetPasswordDoneInbound';
import { RESET_PASSWORD_ERROR_PAYLOAD_DEFINITION } from './recoverLoginInbounds/resetPasswordErrorInbound';
import { ASK_REVERIFY_EMAIL_ACCOUNT_PAYLOAD_DEFINITION } from './reverifyEmailAccountInbounds/askReverifyEmailAccountInbound';
import { REVERIFY_CURRENT_EMAIL_VERIFICATION_SENT_PAYLOAD_DEFINITION } from './reverifyEmailAccountInbounds/reverifyCurrentEmailVerificationSentInbound';
import { REVERIFY_NEW_EMAIL_VERIFICATION_SENT_PAYLOAD_DEFINITION } from './reverifyEmailAccountInbounds/reverifyNewEmailVerificationSentInbound';
import { UPDATE_REVERIFY_EMAIL_ERROR_PAYLOAD_DEFINITION } from './reverifyEmailAccountInbounds/updateReverifyEmailErrorInbound';
import { VERIFY_ACCOUNT_DONE_PAYLOAD_DEFINITION } from './verifyAccountInbounds/verifyAccountDoneInbound';
import { VERIFY_ACCOUNT_ERROR_PAYLOAD_DEFINITION } from './verifyAccountInbounds/verifyAccountErrorInbound';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const ALL_INBOUND_TYPES = [
    'choose_username_error',
    'login_error',
    'login_strs',
    'login_win',
    'login_now',
    'join_lounge',
    'lbrowse_v2',
    'addgames',
    'gamesdone',
    'join',
    'self_data',
    'action_result',
    'action_error',
    'keepalive',
    'lounge',
    'init_game_data_v2',
    'sit',
    'su',
    'sud',
    'enter',
    'h',
    'start_seat_timers',
    'bet',
    'win',
    'show',
    'flop',
    'wait',
    'next_win_anim',
    'btimer',
    'update_players',
    'c',
    'lempty',
    'lcreate',
    'pc',
    'leave',
    'friends_online',
    'friend_hide_active',
    'friend_active',
    'friend_show_request',
    'friend_hide_request',
    'upd_player_bank',
    'sitout_self',
    'sitout',
    'privatemsg',
    'privatemsg_blank',
    'privatemsg_log',
    'private_msgs_recent',
    'lenter',
    'lleave',
    'poker_room_info',
    'hand_recon',
    'msgbox',
    'rebuy_win',
    'become_owner',
    'cbrowse_v2',
    'clounge',
    'center',
    'mtt_update_player_ready_state',
    'lc',
    'cleave',
    'mtt_info_box',
    'hand_rank',
    'update_profile_win',
    'cc',
    'mtt_tables',
    'stat',
    'mtt_close',
    'tourney_summary',
    'mtt_full',
    'mtt_update',
    'chips_win',
    'jacks',
    'lupd_lounge_players',
    'power_player_win',
    'income_win',
    'discard_phase',
    'power_player',
    'confirm_win',
    'lupd',
    'pots',
    'face',
    'next_tourney_win',
    'medals_style',
    'player_info',
    'update_player_blocking',
    'self_info',
    'update_room_var',
    'standings_data',
    'clear_standings_data',
    'newbomb',
    'jacks_win',
    'bounce_player',
    'option',
    'dropdowns',
    'cpls',
    'friends_all_v2',
    'friend_add_to_all',
    'friend_remove_from_all',
    'reveal_this_hand',
    'bubble',
    'account_info',
    'blocked_chat_sql_ids',
    'warn_aggro_betting',
    'hole_cards_after_discard',
    'discard_done',
    'discard_by_seat',
    'il',
    'last_chip_stack',
    'verify_account_error',
    'verify_account_done',
    'ranking_list',
    'chat_blank',
    'side_bet_done',
    'show_give_chips',
    'recent_tourney_winners',
    'request_debug_info',
    'show_player_debug_info',
    'newest_players_list',
    'admin_newest_players_list',
    'rename_current_room',
    'rename_room',
    'recent_admin_actions',
    'prize_win_v2',
    'set_bad_beat_jackpot_amount',
    'update_chip_stacks',
    'show_upcoming_tourneys',
    'version_check_results',
    'show_test_email_log',
    'side_bet_phase',
    'side_bet_added',
    'side_bet_hand_complete',
    'side_bet_hand_incomplete',
    'side_bet_refunded',
    'reload',
    'rebuy_success',
    'free_daily_bonus_success',
    'show_tourney_details',
    'check_recover_login_result',
    'reset_password_error',
    'reset_password_done',
    'ask_reverify_email_account',
    'reverify_current_email_verification_sent',
    'update_reverify_email_error',
    'reverify_new_email_verification_sent',
    'session_id',
    'player_lost_connection',
    'auto_reconnect_invalid'
];
export const INBOUND_DEFINITIONS = {
    choose_username_error: SIGN_UP_ERROR_PAYLOAD_DEFINITION,
    login_error: LOGIN_ERROR_PAYLOAD_DEFINITION,
    login_strs: SET_LOGIN_STRINGS_PAYLOAD_DEFINITION,
    login_win: SHOW_LOGIN_WINDOW_PAYLOAD_DEFINITION,
    login_now: LOGIN_NOW_PAYLOAD_DEFINITION,
    join_lounge: JOIN_LOBBY_PAYLOAD_DEFINITION,
    lbrowse_v2: INIT_LOBBY_PAYLOAD_DEFINITION,
    addgames: ADD_LOBBY_ROOMS_PAYLOAD_DEFINITION,
    gamesdone: LOBBY_ROOMS_DONE_PAYLOAD_DEFINITION,
    join: JOIN_ROOM_PAYLOAD_DEFINITION,
    self_data: SELF_DATA_PAYLOAD_DEFINITION,
    action_result: ACTION_RESULT_PAYLOAD_DEFINITION,
    action_error: ACTION_ERROR_PAYLOAD_DEFINITION,
    keepalive: KEEP_ALIVE_PAYLOAD_DEFINITION,
    lounge: EXIT_POKER_ROOM_TO_LOBBY_PAYLOAD_DEFINITION,
    init_game_data_v2: INIT_POKER_ROOM_INBOUND_DEFINITION,
    sit: SIT_PAYLOAD_DEFINITION,
    su: STAND_UP_INBOUND_DEFINITION,
    sud: STAND_UP_DELAYED_INBOUND_DEFINITION,
    enter: ENTER_POKER_PLAYER_INBOUND_DEFINITION,
    h: START_HAND_INBOUND_DEFINITION,
    start_seat_timers: START_SEAT_TIMERS_PAYLOAD_DEFINITION,
    bet: BET_INBOUND_DEFINITION,
    win: HAND_WIN_INBOUND_DEFINITION,
    show: SHOW_ALL_IN_HANDS_PAYLOAD_DEFINITION,
    flop: SHOW_ALL_IN_COMMUNITY_CARDS_PAYLOAD_DEFINITION,
    wait: WAIT_PHASE_PAYLOAD_DEFINITION,
    next_win_anim: NEXT_WIN_ANIMATION_PAYLOAD_DEFINITION,
    btimer: SET_BLIND_TIMER_PAYLOAD_DEFINITION,
    update_players: UPDATE_PLAYERS_PAYLOAD_DEFINITION,
    c: POKER_ROOM_GENERIC_CHAT_PAYLOAD_DEFINITION,
    lempty: LOBBY_ROOM_REMOVED_PAYLOAD_DEFINITION,
    lcreate: LOBBY_ROOM_CREATED_PAYLOAD_DEFINITION,
    pc: PLAYER_CHAT_PAYLOAD_DEFINITION,
    leave: leavePokerPlayerPayloadDefinition,
    friends_online: SET_ACTIVE_CONTACTS_PAYLOAD_DEFINITION,
    friend_hide_active: SET_CONTACT_INACTIVE_PAYLOAD_DEFINITION,
    friend_active: SET_CONTACT_ACTIVE_PAYLOAD_DEFINITION,
    friend_show_request: SHOW_FRIEND_REQUEST_PAYLOAD_DEFINITION,
    friend_hide_request: HIDE_FRIEND_REQUEST_PAYLOAD_DEFINITION,
    upd_player_bank: SET_ROOM_PLAYER_BANK_PAYLOAD_DEFINITION,
    sitout_self: SIT_OUT_SELF_STATUS_PAYLOAD_DEFINITION,
    sitout: SIT_OUT_STATUS_PAYLOAD_DEFINITION,
    privatemsg: DIRECT_MESSAGE_RECEIVED_PAYLOAD_DEFINITION,
    privatemsg_blank: DIRECT_MESSAGE_BLANK_PAYLOAD_DEFINITION,
    privatemsg_log: DIRECT_MESSAGE_LOG_PAYLOAD_DEFINITION,
    private_msgs_recent: DIRECT_MESSAGES_RECENT_PAYLOAD_DEFINITION,
    lenter: ENTER_LOBBY_PLAYER_PAYLOAD_DEFINITION,
    lleave: LEAVE_LOBBY_PLAYER_PAYLOAD_DEFINITION,
    poker_room_info: POKER_ROOM_INFO_PAYLOAD_DEFINITION,
    hand_recon: HAND_RECONNECT_PAYLOAD_DEFINITION,
    msgbox: MESSAGE_BOX_PAYLOAD_DEFINITION,
    rebuy_win: SHOW_REBUY_WINDOW_PAYLOAD_DEFINITION,
    become_owner: BECOME_OWNER_PAYLOAD_DEFINITION,
    cbrowse_v2: MTT_STAGING_INIT_DATA_PAYLOAD_DEFINITION,
    clounge: EXIT_MTT_STAGING_TO_LOBBY_PAYLOAD_DEFINITION,
    center: ENTER_MTT_STAGING_PLAYER_PAYLOAD_DEFINITION,
    mtt_update_player_ready_state: UPDATE_MTT_STAGING_PLAYER_READY_STATE_PAYLOAD_DEFINITION,
    lc: LOBBY_GENERIC_CHAT_PAYLOAD_DEFINITION,
    cleave: LEAVE_MTT_STAGING_PLAYER_PAYLOAD_DEFINITION,
    mtt_info_box: UPDATE_MTT_STAGING_INFO_PAYLOAD_DEFINITION,
    hand_rank: HAND_RANK_PAYLOAD_DEFINITION,
    update_profile_win: LEGACY_SHOW_PLAYER_INFO_PAYLOAD_DEFINITION,
    cc: MTT_STAGING_GENERIC_CHAT_PAYLOAD_DEFINITION,
    mtt_tables: NUM_MTT_TABLES_PAYLOAD_DEFINITION,
    stat: SET_POKER_ROOM_STATUS_PAYLOAD_DEFINITION,
    mtt_close: CLOSE_MTT_TABLE_PAYLOAD_DEFINITION,
    tourney_summary: TOURNEY_SUMMARY_PAYLOAD_DEFINITION,
    mtt_full: MTT_STAGING_TABLES_PAYLOAD_DEFINITION,
    mtt_update: UPDATE_MTT_STAGING_TABLE_PAYLOAD_DEFINITION,
    chips_win: SHOW_JACKS_TO_CHIPS_PAYLOAD_DEFINITION,
    jacks: UPDATE_JACKS_AND_AMMO_PAYLOAD_DEFINITION,
    lupd_lounge_players: SET_LOBBY_PLAYER_BANK_PAYLOAD_DEFINITION,
    power_player_win: SHOW_POWER_PLAYER_UPGRADE_WINDOW_PAYLOAD_DEFINITION,
    income_win: SHOW_INCOME_EVENT_PAYLOAD_DEFINITION,
    discard_phase: DISCARD_PHASE_PAYLOAD_DEFINITION,
    power_player: SET_POWER_PLAYER_STATUS_PAYLOAD_DEFINITION,
    confirm_win: SHOW_CONFIRM_WINDOW_PAYLOAD_DEFINITION,
    lupd: UPDATE_LOBBY_ROOM_PAYLOAD_DEFINITION,
    pots: UPDATE_POT_AMOUNTS_INBOUND_DEFINITION,
    face: SET_SEATED_PLAYER_AVATAR_PAYLOAD_DEFINITION,
    next_tourney_win: SHOW_NEXT_TOURNEY_WINDOW_PAYLOAD_DEFINITION,
    medals_style: UPDATE_PLAYER_MEDALS_AND_STYLE_PAYLOAD_DEFINITION,
    player_info: SHOW_PLAYER_INFO_PAYLOAD_DEFINITION,
    update_player_blocking: UPDATE_PLAYER_BLOCKING_PAYLOAD_DEFINITION,
    self_info: SHOW_SELF_INFO_PAYLOAD_DEFINITION,
    update_room_var: UPDATE_LOBBY_ROOM_VARIABLE_PAYLOAD_DEFINITION,
    standings_data: UPDATE_TOURNEY_STANDINGS_INBOUND_DEFINITION,
    clear_standings_data: CLEAR_TOURNEY_STANDINGS_INBOUND_DEFINITION,
    newbomb: ADD_BOMB_PAYLOAD_DEFINITION,
    jacks_win: SHOW_JACKS_WINDOW_PAYLOAD_DEFINITION,
    bounce_player: BOUNCE_SEATED_PLAYER_PAYLOAD_DEFINITION,
    option: UPDATE_PLAYER_SERVER_SETTING_PAYLOAD_DEFINITION,
    dropdowns: SHOW_DROP_DOWN_MENU_PAYLOAD_DEFINITION,
    cpls: UPDATE_MTT_STAGING_PLAYERS_PAYLOAD_DEFINITION,
    friends_all_v2: SET_ALL_FRIENDS_PAYLOAD_DEFINITION,
    friend_add_to_all: ADD_FRIEND_TO_ALL_PAYLOAD_DEFINITION,
    friend_remove_from_all: REMOVE_FRIEND_FROM_ALL_PAYLOAD_DEFINITION,
    reveal_this_hand: SET_HAND_REVEALING_PAYLOAD_DEFINITION,
    bubble: SHOW_PLAYER_BUBBLE_PAYLOAD_DEFINITION,
    account_info: ACCOUNT_INFO_PAYLOAD_DEFINITION,
    blocked_chat_sql_ids: SET_BLOCKED_CHAT_PLAYERS_PAYLOAD_DEFINITION,
    warn_aggro_betting: WARN_AGGRO_BETTING_PAYLOAD_DEFINITION,
    hole_cards_after_discard: SET_HOLE_CARDS_AFTER_DISCARD_PAYLOAD_DEFINITION,
    discard_done: SET_DISCARD_PHASE_DONE_PAYLOAD_DEFINITION,
    discard_by_seat: SET_PLAYER_HAS_DISCARDED_PAYLOAD_DEFINITION,
    il: INFINITE_LOOP_PAYLOAD_DEFINITION,
    last_chip_stack: LAST_CHIP_STACK_INBOUND_DEFINITION,
    verify_account_error: VERIFY_ACCOUNT_ERROR_PAYLOAD_DEFINITION,
    verify_account_done: VERIFY_ACCOUNT_DONE_PAYLOAD_DEFINITION,
    ranking_list: SHOW_RANKING_LIST_PAYLOAD_DEFINITION,
    chat_blank: SHOW_BLANK_CHAT_BUBBLE_PAYLOAD_DEFINITION,
    side_bet_done: SIDE_BET_DONE_PAYLOAD_DEFINITION,
    show_give_chips: SHOW_GIVE_CHIPS_PAYLOAD_DEFINITION,
    recent_tourney_winners: RECENT_TOURNEY_WINNERS_PAYLOAD_DEFINITION,
    request_debug_info: REQUEST_DEBUG_INFO_PAYLOAD_DEFINITION,
    show_player_debug_info: SHOW_PLAYER_DEBUG_INFO_PAYLOAD_DEFINITION,
    newest_players_list: NEWEST_PLAYERS_LIST_PAYLOAD_DEFINITION,
    admin_newest_players_list: ADMIN_NEWEST_PLAYERS_LIST_PAYLOAD_DEFINITION,
    rename_current_room: RENAME_CURRENT_ROOM_PAYLOAD_DEFINITION,
    rename_room: RENAME_ROOM_PAYLOAD_DEFINITION,
    recent_admin_actions: RECENT_ADMIN_ACTIONS_PAYLOAD_DEFINITION,
    prize_win_v2: SHOW_PRIZE_WIN_PAYLOAD_DEFINITION,
    set_bad_beat_jackpot_amount: SET_BAD_BEAT_JACKPOT_AMOUNT_PAYLOAD_DEFINITION,
    update_chip_stacks: UPDATE_CHIP_STACKS_PAYLOAD_DEFINITION,
    show_upcoming_tourneys: SHOW_UPCOMING_TOURNEYS_PAYLOAD_DEFINITION,
    version_check_results: VERSION_CHECK_RESULTS_PAYLOAD_DEFINITION,
    show_test_email_log: SHOW_TEST_EMAIL_LOG_PAYLOAD_DEFINITION,
    side_bet_phase: SIDE_BET_PHASE_PAYLOAD_DEFINITION,
    side_bet_added: SIDE_BET_ADDED_PAYLOAD_DEFINITION,
    side_bet_hand_complete: SIDE_BET_HAND_COMPLETE_PAYLOAD_DEFINITION,
    side_bet_hand_incomplete: SIDE_BET_HAND_INCOMPLETE_PAYLOAD_DEFINITION,
    side_bet_refunded: SIDE_BET_REFUNDED_PAYLOAD_DEFINITION,
    reload: RELOAD_PAYLOAD_DEFINITION,
    rebuy_success: REBUY_SUCCESS_PAYLOAD_DEFINITION,
    free_daily_bonus_success: FREE_DAILY_BONUS_SUCCESS_PAYLOAD_DEFINITION,
    show_tourney_details: SHOW_TOURNEY_DETAILS_PAYLOAD_DEFINITION,
    check_recover_login_result: CHECK_RECOVER_LOGIN_PAYLOAD_DEFINITION,
    reset_password_error: RESET_PASSWORD_ERROR_PAYLOAD_DEFINITION,
    reset_password_done: RESET_PASSWORD_DONE_PAYLOAD_DEFINITION,
    ask_reverify_email_account: ASK_REVERIFY_EMAIL_ACCOUNT_PAYLOAD_DEFINITION,
    reverify_current_email_verification_sent: REVERIFY_CURRENT_EMAIL_VERIFICATION_SENT_PAYLOAD_DEFINITION,
    update_reverify_email_error: UPDATE_REVERIFY_EMAIL_ERROR_PAYLOAD_DEFINITION,
    reverify_new_email_verification_sent: REVERIFY_NEW_EMAIL_VERIFICATION_SENT_PAYLOAD_DEFINITION,
    session_id: SESSION_ID_PAYLOAD_DEFINITION,
    player_lost_connection: PLAYER_LOST_CONNECTION_PAYLOAD_DEFINITION,
    auto_reconnect_invalid: AUTO_RECONNECT_INVALID_PAYLOAD_DEFINITION
};
